// extracted by mini-css-extract-plugin
export default {"login":"Login_login__zZMhz","form":"Login_form__EdsYV","field":"Login_field__dTPpZ","inputFull":"Login_inputFull__v2tQQ","links":"Login_links__xuxD-","error":"Login_error__gJDdZ"};